import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    cancelButton: {
        '&:hover': {
            backgroundColor: theme.palette.info.dark,

        },
        backgroundColor: theme.palette.info.dark,
        color: theme.palette.common.white,
    },
    cancelIcon: {
        fill: theme.palette.common.white
    },
    deleteButton: {
        '&:hover': {
            backgroundColor: theme.palette.error.dark,
        },
        backgroundColor: theme.palette.error.main,
        color: theme.palette.common.white,
    },
    deleteIcon: {
        fill: theme.palette.common.white
    },
}))

